document.addEventListener('DOMContentLoaded', function() {
  // Function to handle tab switching
  function switchTab(tabName) {
    // Get all tab buttons and content areas on the page
    const allButtons = document.querySelectorAll('.description-tab-btn');
    const allContents = document.querySelectorAll('.tab-content');
    
    // Update all buttons
    allButtons.forEach(button => {
      button.classList.toggle('active', button.dataset.tab === tabName);
    });
    
    // Update all content areas
    allContents.forEach(content => {
      content.classList.toggle('active', content.dataset.tabContent === tabName);
    });
  }
  
  // Add event listeners to all tab buttons
  document.querySelectorAll('.description-tab-btn').forEach(button => {
    button.addEventListener('click', () => {
      const tabName = button.dataset.tab;
      switchTab(tabName);
    });
  });
});